export const flyzagolEndpoints = {
  paymentQuery: "flyzagolApp/services/searchFlyzagolPnr",
  payment: "flyzagolApp/services/payFlyzagolPayment",
};

export const flyzagolConst = [
  {
    title: "Flyzagol Payment",
    labels: [
      "Select Account Number",
      "Enter PNR",
      "Search",
      "PNR",
      "Passenger Name",
      "Amount",
      "Continue",
    ],
    confirmationTitle: "Confirm Flyzagol payment",
  },
  {
    title: "የFlyzagol ክፍያ",
    labels: [
      "የሂሳብ ቁጥር ይምረጡ",
      "PNR ያስገቡ",
      "ፈልግ",
      "PNR",
      "የተሳፋሪ ስም",
      "መጠን",
      "ቀጥል",
    ],
    confirmationTitle: "የFlyzagol ክፍያን ያረጋግጡ",
  },
  {
    title: "Kaffaltii Flyzagol",
    labels: [
      "Lakkoofsa Herregaa Filadhu",
      "PNR Galchi",
      "Barbaadi",
      "PNR",
      "Maqaa Imaltuu",
      "Baay'ina",
      "Itti Fufi",
    ],
    confirmationTitle: "Kaffaltii Flyzagol mirkaneessi",
  },
  {
    title: "ክፍሊት Flyzagol",
    labels: [
      "ቁጽሪ ሕሳብ ምረጽ",
      "PNR ኣእትው",
      "ድለ",
      "PNR",
      "ስም ተጓዓዛይ",
      "መጠን",
      "ቀጽል",
    ],
    confirmationTitle: "ክፍሊት Flyzagol ኣረጋግጽ",
  },
  {
    title: "Bixinta Flyzagol",
    labels: [
      "Xisaab Nambarka Dooro",
      "Geli PNR",
      "Raadi",
      "PNR",
      "Magaca Rakaabka",
      "Qadarka",
      "Sii Soco",
    ],
    confirmationTitle: "Xaqiiji bixinta Flyzagol",
  },
  {
    title: "Flyzagol Mekla",
    labels: [
      "Hisab Nummara Yokale",
      "PNR Culusa",
      "Gexso",
      "PNR",
      "Safar Migaq",
      "Qadaana",
      "Itteh",
    ],
    confirmationTitle: "Flyzagol mekla asmatis",
  },
];
